import { EcommerceCategories, RemoteConfig } from '../../models';

export const remoteConfigs: RemoteConfig = {
  appVersionCode: 1,
  createdAt: new Date(),
  id: 'remote-configs',
  paymentGatewayEnabled: true,
  updatedAt: new Date(),
};

export const ecommerceCategories: EcommerceCategories = {
  createdAt: new Date(),
  id: 'ecommerce-categories',
  items: [
    {
      id: 'tv-y-video',
      label: 'TV y video',
      description: 'Encuentra televisores, proyectores, dispositivos de streaming y accesorios para disfrutar de la mejor experiencia audiovisual en tu hogar.',
      status: 'inactive',
      subcategories: [
        {
          id: 'televisiones',
          label: 'Televisiones',
          description: 'Televisores de diferentes tamaños y tecnologías para una experiencia visual inigualable.',
          partnerIds: [
            20082,
          ],
          satCode: '52161500',
          status: 'inactive',
        },
        {
          id: 'dispositivos-streaming',
          label: 'Dispositivos streaming',
          description: 'Dispositivos para transmitir contenido digital a tu televisor o pantalla.',
          partnerIds: [
            20083,
          ],
          satCode: '45111800',
          status: 'inactive',
        },
        {
          id: 'proyectores-y-pantallas',
          label: 'Proyectores y pantallas',
          description: 'Proyectores y pantallas para presentaciones y entretenimiento en casa.',
          partnerIds: [
            20084,
          ],
          satCode: '52161505',
          status: 'inactive',
        },
        {
          id: 'reproductores-bluray-y-dvds',
          label: 'Reproductores bluray y dvds',
          description: 'Reproductores de Blu-ray y DVD para ver tus películas y series favoritas.',
          partnerIds: [
            20085,
          ],
          satCode: '52161500',
          status: 'inactive',
        },
        {
          id: 'soportes',
          label: 'Soportes',
          description: 'Soportes y bases para televisores y equipos de video.',
          partnerIds: [
            20086,
          ],
          satCode: '45111800',
          status: 'inactive',
        },
        {
          id: 'accesorios-tv-y-video',
          label: 'Accesorios tv y video',
          description: 'Accesorios para complementar y mejorar tu experiencia de TV y video.',
          partnerIds: [
            20088,
          ],
          satCode: '45111800',
          status: 'inactive',
        },
        {
          id: 'refacciones',
          label: 'Refacciones',
          description: 'Refacciones y repuestos para equipos de TV y video.',
          partnerIds: [
            22181,
          ],
          satCode: '45111800',
          status: 'inactive',
        },
      ],
    },
    {
      id: 'audio-y-sonido',
      label: 'Audio y sonido',
      description: 'Todo en audio: audífonos, bocinas, teatros en casa, amplificadores y accesorios para una experiencia sonora superior.',
      status: 'active',
      subcategories: [
        {
          id: 'audifonos-y-manos-libres',
          label: 'Audífonos y manos libres',
          description: 'Audífonos y dispositivos manos libres para escuchar música y atender llamadas con comodidad.',
          partnerIds: [
            20090,
          ],
          satCode: '52161514',
          status: 'inactive',
        },
        {
          id: 'teatro-en-casa',
          label: 'Teatro en casa',
          description: 'Sistemas de teatro en casa para una experiencia de cine en tu hogar.',
          partnerIds: [
            20091,
          ],
          satCode: '52161500',
          status: 'inactive',
        },
        {
          id: 'amplificadores',
          label: 'Amplificadores',
          description: 'Amplificadores de audio para mejorar la potencia y calidad del sonido.',
          partnerIds: [
            20092,
          ],
          satCode: '52161500',
          status: 'inactive',
        },
        {
          id: 'audio-para-auto',
          label: 'Audio para auto',
          description: 'Equipos de audio especializados para automóviles.',
          partnerIds: [
            20093,
          ],
          satCode: '52161500',
          status: 'inactive',
        },
        {
          id: 'bocinas',
          label: 'Bocinas',
          description: 'Bocinas de diferentes tipos y tamaños para todo tipo de espacios.',
          partnerIds: [
            20094,
          ],
          satCode: '52161500',
          status: 'inactive',
        },
        {
          id: 'consolas-y-mezcladoras',
          label: 'Consolas y mezcladoras',
          description: 'Consolas y mezcladoras de audio para DJs y profesionales del sonido.',
          partnerIds: [
            20095,
          ],
          satCode: '52161500',
          status: 'inactive',
        },
        {
          id: 'mincomponentes-y-receptores',
          label: 'Minicomponentes y receptores',
          description: 'Minicomponentes y receptores para sistemas de audio completos.',
          partnerIds: [
            20096,
          ],
          satCode: '52161500',
          status: 'inactive',
        },
        {
          id: 'accesorios-audio-y-sonido',
          label: 'Accesorios audio y sonido',
          description: 'Accesorios para equipos de audio y sonido.',
          partnerIds: [
            20097,
          ],
          satCode: '52161600',
          status: 'inactive',
        },
      ],
    },
    {
      id: 'entretenimiento-y-tecnologia',
      label: 'Entretenimiento y tecnología',
      description: '',
      status: 'active',
      subcategories: [
        {
          id: 'videocamaras',
          label: 'Videocámaras',
          description: '',
          partnerIds: [
            20099,
          ],
          satCode: '45121500',
          status: 'active',
        },
        {
          id: 'camaras-analogicas',
          label: 'Camaras analógicas',
          description: '',
          partnerIds: [
            20100,
          ],
          satCode: '45121500',
          status: 'active',
        },
        {
          id: 'camaras-digitales',
          label: 'Camaras digitales',
          description: '',
          partnerIds: [
            20101,
          ],
          satCode: '45121500',
          status: 'active',
        },
        {
          id: 'reflex-semiprofesionales',
          label: 'Reflex semiprofesionales',
          description: '',
          partnerIds: [
            20102,
          ],
          satCode: '45121500',
          status: 'active',
        },
        {
          id: 'drones',
          label: 'Drones',
          description: '',
          partnerIds: [
            20103,
          ],
          satCode: '45121500',
          status: 'active',
        },
        {
          id: 'go-pro',
          label: 'Go pro',
          description: '',
          partnerIds: [
            20104,
          ],
          satCode: '45121500',
          status: 'active',
        },
        {
          id: 'accesorios-fotografia',
          label: 'Accesorios fotografía',
          description: '',
          partnerIds: [
            20105,
          ],
          satCode: '45121600',
          status: 'active',
        },
        {
          id: 'binoculares-y-telescopios',
          label: 'Binoculares y telescopios',
          description: '',
          partnerIds: [
            22201,
          ],
          satCode: '41111700',
          status: 'active',
        },
        {
          id: 'computo-y-tabletas',
          label: 'Computo y tablets',
          description: '',
          partnerIds: [
            20107,
            20108,
            20109,
            20110,
            20111,
            20112,
            20113,
            20114,
            20115,
            20116,
            22182,
            21974,
          ],
          satCode: '43211500',
          status: 'active',
        },
        {
          id: 'videojuegos',
          label: 'Videojuegos',
          description: '',
          partnerIds: [
            20121,
            20122,
            20123,
            21971,
            20125,
            20126,
            20127,
            21972,
            20129,
            20130,
            20131,
            21973,
            20133,
            20134,
            20135,
            22191,
            21979,
          ],
          satCode: '43232000',
          status: 'active',
        },
      ],
    },
    {
      id: 'muebles-y-decoracion',
      label: 'Muebles y decoración',
      description: 'Descubre la mejor selección de muebles y decoración para tu hogar. Encuentra salas, recámaras, colchones, decoración, iluminación y más para crear el ambiente perfecto en cada espacio de tu casa.',
      status: 'active',
      subcategories: [
        {
          id: 'salas-y-family-room',
          label: 'Salas y family room',
          description: 'Encuentra las mejores salas y muebles para family room. Sofás, loveseats, mesas de centro y más para crear el espacio perfecto para reuniones familiares y entretenimiento.',
          partnerIds: [
            20137,
          ],
          satCode: '56101500',
          status: 'active',
        },
        {
          id: 'colchones-y-boxes',
          label: 'Colchones y boxes',
          description: 'Descansa mejor con nuestra selección de colchones y box springs de calidad. Encuentra el colchón perfecto para tu descanso con las mejores marcas y tecnologías.',
          partnerIds: [
            20165,
          ],
          satCode: '56101500',
          status: 'active',
        },
        {
          id: 'comedor-y-cocina',
          label: 'Comedor y cocina',
          description: 'Equipa tu hogar con muebles y accesorios para comedor y cocina. Mesas, sillas, alacenas y más para crear espacios funcionales y acogedores.',
          partnerIds: [
            20154,
            20231,
          ],
          satCode: '56101500',
          status: 'active',
        },
        {
          id: 'recamaras',
          label: 'Recámaras',
          description: 'Crea tu santuario personal con muebles de recámara. Camas, burós, roperos y más para diseñar el dormitorio de tus sueños con estilo y funcionalidad.',
          partnerIds: [
            20175,
          ],
          satCode: '56101500',
          status: 'active',
        },
        {
          id: 'banos',
          label: 'Baño',
          description: 'Equipa tu baño con muebles y accesorios de calidad. Gabinetes, espejos, toalleros y más para crear un espacio funcional y elegante en tu baño.',
          partnerIds: [
            20209,
          ],
          satCode: '56101500',
          status: 'active',
        },
        {
          id: 'decoracion',
          label: 'Decoración',
          description: 'Transforma tu hogar con elementos de decoración únicos. Cuadros, plantas, cojines y más para dar personalidad y estilo a cada rincón de tu casa.',
          partnerIds: [
            20190,
          ],
          satCode: '49101609',
          status: 'active',
        },
        {
          id: 'limpieza-y-organizacion',
          label: 'Limpieza y organización',
          description: 'Mantén tu hogar impecable con productos de limpieza y organización. Organizadores, productos de limpieza y más para un espacio ordenado y funcional.',
          partnerIds: [
            20217,
          ],
          satCode: '47131700',
          status: 'active',
        },
        {
          id: 'blancos',
          label: 'Blancos',
          description: 'Encuentra la mejor ropa de cama y blancos para tu hogar. Sábanas, edredones, toallas y más con los mejores materiales y diseños.',
          partnerIds: [
            20251,
          ],
          satCode: '52121500',
          status: 'active',
        },
        {
          id: 'iluminacion',
          label: 'Iluminación',
          description: 'Ilumina tu hogar con estilo. Lámparas, focos, candiles y más para crear la atmósfera perfecta en cada espacio de tu casa.',
          partnerIds: [
            20749,
            20751,
            20753,
          ],
          satCode: '39000000',
          status: 'active',
        },
      ],
    },
    {
      id: 'electrodomesticos-y-linea-blanca',
      label: 'Electrodomésticos y línea blanca',
      description: 'Encuentra electrodomésticos y línea blanca de las mejores marcas. Refrigeradores, lavadoras, estufas, aspiradoras y más para equipar tu cocina y hogar con tecnología de vanguardia.',
      status: 'active',
      subcategories: [
        {
          id: 'electrodomesticos',
          label: 'Electrodomésticos',
          description: 'Encuentra los mejores electrodomésticos para tu hogar. Pequeños electrodomésticos que facilitan tu día a día con tecnología avanzada.',
          partnerIds: [
            20282,
          ],
          satCode: '52141500',
          status: 'active',
        },
        {
          id: 'refrigeradores',
          label: 'Refrigeradores',
          description: 'Conserva tus alimentos con refrigeradores de las mejores marcas. Encuentra el refrigerador perfecto para tu cocina con diferentes capacidades y tecnologías.',
          partnerIds: [
            20314,
          ],
          satCode: '52141500',
          status: 'active',
        },
        {
          id: 'para-cocinar',
          label: 'Para cocinar',
          description: 'Equipa tu cocina con los mejores aparatos para cocinar. Estufas, hornos, microondas y más para preparar deliciosas comidas en casa.',
          partnerIds: [
            20318,
            20330,
          ],
          satCode: '52141500',
          status: 'active',
        },
        {
          id: 'lavado-y-secado-de-ropa',
          label: 'Lavado y secado de ropa',
          description: 'Simplifica el cuidado de tu ropa con lavadoras y secadoras de calidad. Encuentra el equipo perfecto para mantener tu ropa limpia y fresca.',
          partnerIds: [
            20324,
          ],
          satCode: '52141500',
          status: 'active',
        },
        {
          id: 'climatizacion',
          label: 'Climatización',
          description: 'Mantén el clima perfecto en tu hogar con equipos de climatización. Aire acondicionado, calefactores y más para tu comodidad todo el año.',
          partnerIds: [
            20331,
          ],
          satCode: '52141500',
          status: 'active',
        },
        {
          id: 'aspiradoras',
          label: 'Aspiradoras',
          description: 'Mantén tu hogar limpio con aspiradoras de última generación. Encuentra la aspiradora perfecta para cada tipo de superficie y necesidad.',
          partnerIds: [
            20758,
          ],
          satCode: '47121602',
          status: 'active',
        },
        {
          id: 'hidrolavadoras-y-herramientas',
          label: 'Hidrolavadoras y herramientas',
          description: 'Limpia y mantén tu hogar con hidrolavadoras y herramientas profesionales. Equipos de limpieza para interiores y exteriores.',
          partnerIds: [
            20760,
          ],
          satCode: '21101801',
          status: 'active',
        },
      ],
    },
    {
      id: 'estudio-y-oficina',
      label: 'Estudio y oficina',
      description: 'Equipa tu espacio de trabajo con libros, revistas y todo lo necesario para tu estudio u oficina. Productos de calidad para maximizar tu productividad y crear un ambiente profesional.',
      status: 'active',
      subcategories: [
        {
          id: 'libros-y-revistas',
          label: 'Libros y revistas',
          description: 'Amplía tu conocimiento con nuestra selección de libros y revistas. Literatura, manuales, revistas especializadas y más para tu desarrollo personal y profesional.',
          partnerIds: [
            21303,
            21306,
            21308,
            21311,
            21315,
            21316,
            21317,
            21323,
            21325,
            21326,
            21329,
            21330,
            21331,
            21332,
            21333,
            21334,
            21335,
            21336,
            21338,
            21339,
            21975,
            21976,
            21305,
            21307,
            21309,
            21310,
            21312,
            21313,
            21314,
            21318,
            21319,
            21320,
            21321,
            21322,
            21324,
            21327,
            21328,
            21337,
          ],
          satCode: '60000000',
          status: 'active',
        },
      ],
    },
    {
      id: 'mascotas',
      label: 'Mascotas',
      description: 'Todo para el cuidado y bienestar de tus mascotas. Productos especializados para perros, gatos y aves. Alimentación, juguetes, accesorios y más para consentir a tus compañeros peludos.',
      status: 'active',
      subcategories: [
        {
          id: 'perro',
          label: 'Perro',
          description: 'Todo para el cuidado y diversión de tu perro. Alimentación, juguetes, accesorios y más para consentir a tu mejor amigo canino.',
          partnerIds: [
            21851,
            21852,
            21853,
            21854,
            21856,
            21867,
            21870,
            21904,
            21905,
            21855,
            21857,
            21858,
            21859,
            21860,
            21861,
            21862,
            21863,
            21864,
            21865,
            21866,
            22187,
          ],
          satCode: '10111302',
          status: 'active',
        },
        {
          id: 'gato',
          label: 'Gato',
          description: 'Productos especializados para el cuidado de tu gato. Alimentación, juguetes, rascadores y más para el bienestar de tu felino.',
          partnerIds: [
            21877,
          ],
          satCode: '10111302',
          status: 'active',
        },
        {
          id: 'aves',
          label: 'Aves',
          description: 'Cuida y alimenta a tus aves con productos especializados. Alimentación, jaulas, accesorios y más para el cuidado de tus pájaros.',
          partnerIds: [
            21899,
            21898,
            21900,
            21901,
            21902,
            21903,
          ],
          satCode: '10111302',
          status: 'active',
        },
      ],
    },
    {
      id: 'patio-y-jardin',
      label: 'Patio y jardín',
      description: 'Transforma tu espacio exterior con muebles de jardín, carpas, decoración al aire libre y herramientas de jardinería. Crea el patio de tus sueños y disfruta de momentos al aire libre.',
      status: 'active',
      subcategories: [
        {
          id: 'muebles-para-jardin',
          label: 'Muebles para jardín',
          description: 'Crea espacios de convivencia al aire libre con muebles de jardín. Mesas, sillas, sombrillas y más para disfrutar de tu patio.',
          partnerIds: [
            20339,
          ],
          satCode: '56101500',
          status: 'active',
        },
        {
          id: 'carpas',
          label: 'Carpas',
          description: 'Protege tu espacio exterior con carpas y toldos de calidad. Soluciones para crear sombra y protección en tu jardín o patio.',
          partnerIds: [
            20342,
          ],
          satCode: '56101532',
          status: 'active',
        },
        {
          id: 'asadores',
          label: 'Asadores',
          description: 'Prepara deliciosas parrilladas con nuestros asadores. Ideales para reuniones al aire libre, con opciones a gas, carbón y eléctricos para todo tipo de espacios.',
          partnerIds: [
            20344,
          ],
          satCode: '56101532',
          status: 'active',
        },
        {
          id: 'decoracion-al-aire-libre',
          label: 'Decoración al aire libre',
          description: 'Decora tu espacio exterior con elementos diseñados para el aire libre. Macetas, fuentes, esculturas y más para embellecer tu jardín.',
          partnerIds: [
            20346,
          ],
          satCode: '49101609',
          status: 'active',
        },
        {
          id: 'jardineria',
          label: 'Jardineria',
          description: 'Cuida tu jardín con herramientas y productos de jardinería profesionales. Herramientas, fertilizantes, semillas y más para un jardín hermoso.',
          partnerIds: [
            20732,
            20733,
            20734,
            20736,
            20737,
            20738,
            20739,
            20741,
            20742,
            20746,
          ],
          satCode: '27112000',
          status: 'active',
        },
      ],
    },
    {
      id: 'construccion-y-ferreteria',
      label: 'Construcción y ferretería',
      description: 'Herramientas y materiales de construcción de calidad profesional. Encuentra todo para electricidad, plomería, carpintería y construcción. Productos duraderos para tus proyectos.',
      status: 'active',
      subcategories: [
        {
          id: 'electricidad',
          label: 'Electricidad',
          description: 'Encuentra todo para instalaciones eléctricas. Cables, interruptores, focos y más para proyectos eléctricos seguros y profesionales.',
          partnerIds: [
            20656,
            20661,
            20662,
            20663,
            20665,
          ],
          satCode: '39121700',
          status: 'active',
        },
        {
          id: 'herramientas',
          label: 'Herramientas',
          description: 'Equipa tu taller con herramientas profesionales. Herramientas manuales y eléctricas para todo tipo de proyectos y reparaciones.',
          partnerIds: [
            20667,
            20669,
            20670,
            20671,
            20672,
            20673,
            20674,
            20676,
            20689,
            20690,
            20705,
            20709,
          ],
          satCode: '40141700',
          status: 'active',
        },
        {
          id: 'plomeria',
          label: 'Plomería',
          description: 'Soluciona problemas de plomería con productos de calidad. Tuberías, válvulas, accesorios y más para instalaciones y reparaciones.',
          partnerIds: [
            20724,
            20725,
          ],
          satCode: '40183000',
          status: 'active',
        },
        {
          id: 'carpinteria',
          label: 'Carpintería',
          description: 'Realiza proyectos de carpintería con herramientas y materiales especializados. Maderas, herramientas y accesorios para trabajos de carpintería.',
          partnerIds: [
            20728,
            20729,
            20730,
          ],
          satCode: '39121700',
          status: 'active',
        },
        {
          id: 'construccion',
          label: 'Construcción',
          description: 'Materiales de construcción de calidad para tus proyectos. Cemento, ladrillos, arena y más para construcciones duraderas y seguras.',
          partnerIds: [
            20763,
            20771,
          ],
          satCode: '39121700',
          status: 'active',
        },
      ],
    },
    {
      id: 'deporte-y-estilo-de-vida',
      label: 'Deporte y estilo de vida',
      description: 'Mantén un estilo de vida activo con aparatos de ejercicio y equipaje de calidad. Productos diseñados para deportistas y viajeros que buscan funcionalidad y durabilidad.',
      status: 'active',
      subcategories: [
        {
          id: 'aparatos-de-ejercicio',
          label: 'Aparatos de ejercicio',
          description: 'Mantén tu rutina de ejercicio en casa con aparatos de calidad. Bicicletas estáticas, caminadoras, pesas y más para tu entrenamiento.',
          partnerIds: [
            20454,
            20455,
            20456,
            20458,
            21839,
          ],
          satCode: '42251600',
          status: 'active',
        },
        {
          id: 'equipaje',
          label: 'Equipaje',
          description: 'Viaja con estilo y comodidad con maletas y equipaje de calidad. Maletas, mochilas, bolsas de viaje y más para tus aventuras.',
          partnerIds: [
            21810,
            21811,
            21812,
            21813,
            21814,
            21816,
            21843,
          ],
          satCode: '53121500',
          status: 'active',
        },
      ],
    },
    {
      id: 'juegos-y-juguetes',
      label: 'Juegos y juguetes',
      description: 'Diversión para toda la familia con brincolines, albercas, juguetes y juegos de mesa. Crea momentos inolvidables con productos seguros y entretenidos para todas las edades.',
      status: 'active',
      subcategories: [
        {
          id: 'brincolines-albercas-y-plazas',
          label: 'Brincolines, albercas y plazas',
          description: 'Diversión al aire libre para toda la familia. Brincolines, albercas inflables y juegos de plaza para crear momentos inolvidables.',
          partnerIds: [
            21231,
            21233,
            21236,
          ],
          satCode: '49241500',
          status: 'active',
        },
        {
          id: 'juguetes',
          label: 'Juguetes',
          description: 'Estimula la imaginación y creatividad con juguetes educativos y divertidos. Juguetes para todas las edades que promueven el desarrollo y la diversión.',
          partnerIds: [
            21211,
            21217,
            21227,
            21265,
            21274,
            21281,
          ],
          satCode: '60141000',
          status: 'active',
        },
        {
          id: 'juegos-de-mesa',
          label: 'Juegos de mesa',
          description: 'Crea momentos de convivencia familiar con juegos de mesa entretenidos. Juegos clásicos y modernos para todas las edades y gustos.',
          partnerIds: [
            21238,
            21239,
            21240,
            21241,
            21242,
            21243,
            21244,
            21245,
            21246,
            21247,
            21248,
            21249,
            21260,
            21261,
          ],
          satCode: '60141102',
          status: 'active',
        },
      ],
    },
    {
      id: 'maternidad-y-bebe',
      label: 'Maternidad y bebé',
      description: 'Todo lo que necesitas para el cuidado de tu bebé. Productos especializados para la hora del baño y la hora de dormir. Calidad y seguridad para los momentos más importantes de tu pequeño.',
      status: 'active',
      subcategories: [
        {
          id: 'hora-del-bano',
          label: 'Hora del baño',
          description: 'Todo lo necesario para la hora del baño de tu bebé. Tinas, jabones, toallas y más para hacer del baño un momento especial y seguro.',
          partnerIds: [
            22382,
            22383,
          ],
          satCode: '53131647',
          status: 'active',
        },
        {
          id: 'hora-de-dormir',
          label: 'Hora de dormir',
          description: 'Crea un ambiente tranquilo para el descanso de tu bebé. Cunas, ropa de cama, música y más para una hora de dormir relajante y segura.',
          partnerIds: [
            22384,
            22385,
            22386,
            22387,
            22392,
            22394,
            22395,
          ],
          satCode: '53131647',
          status: 'active',
        },
      ],
    },
  ],
  updatedAt: new Date(),
};